<template>
  <div class="addAccountingComputerizationNotice">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1" slot="title">
        <div class="newsDetial-title">{{ Form.titleName || "" }}</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">审批流程</div>
        <blank height="7"> </blank>
        <!-- <a-button
          class="detial-top-btn"
          type="primary"
          icon="printer"
          v-if="Form.state == 2"
          @click="printDDD()"
        >
          打印
        </a-button> -->
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">新建表单</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照文本要求添加表单，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-show="tabnum == 1">
      <div class="detial-cont-title">
        基本信息
        <template v-if="!sendType.includes(2)">
          <a-button
            v-show="id && Form.state != 4"
            :loading="WorkLoading"
            class="title-btn"
            type="primary"
            icon="play-circle"
            @click="createWork"
          >
            预览</a-button
          >
        </template>
      </div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="通知标题"
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.titleName"
              :disabled="disabled"
              @change="eightyfive('titleName')"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">发起部门<span class="required">*</span></span>
            <a-tooltip placement="topLeft" :title="Form.organizationName">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organizationName"
                  :disabled="disabled"
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">发起人<span class="required">*</span> </span>
            <a-select
              disabled
              placeholder="请添加"
              class="w300"
              v-model="Form.initatorId"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace">
              接收人
              <span class="required">*</span>
            </span>
            <a-select
              mode="multiple"
              placeholder="请添加"
              class="w800"
              :filter-option="filterOption"
              v-model="Form.sendList"
              :disabled="disabled"
            >
              <template v-for="i in GroupList">
                <a-select-option :value="i.id" :key="i.id">{{
                  i.groupName
                }}</a-select-option>
              </template>
            </a-select>
            <a-checkbox-group
              v-model="sendType"
              name="checkboxValue"
              :options="checkboxOptions"
              style="margin-left: 20px"
              @change="changeSendWay"
            />
          </a-descriptions-item>

          <!-- <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace">
              抄送
              <span class="required">*</span>
            </span>
            <a-select
              mode="multiple"
              placeholder="请添加"
              class="w800"
              :filter-option="filterOption"
              v-model="Form.copypresentList"
              :disabled="disabled"
            >
              <template v-for="i in GroupList">
                <a-select-option v-if="i.type == 2" :value="i.id" :key="i.id">{{
                  i.groupName
                }}</a-select-option>
              </template>
            </a-select>
          </a-descriptions-item> -->
        </a-descriptions>
        <!-- 标题 -->
        <h2 style="text-align: center; font-weight: 600; margin-top: 20px">
          通知内容
        </h2>
        <div class="edui-default" v-show="!disabled">
          <template>
            <div v-show="!sendType.includes(2)">
              <script id="editor" ref="ueditor" type="text/plain"></script>
            </div>
            <a-textarea
              v-model="Form.text"
              placeholder="请输入"
              :auto-size="{ minRows: 5, maxRows: 5 }"
              v-if="sendType.includes(2)"
            ></a-textarea>
            <blank height="15"> </blank>
          </template>
        </div>
        <div
          v-if="disabled"
          class="newsDetial-cont-view"
          v-html="Form.text"
        ></div>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <!-- 附件 -->
      <accessories-table
        v-if="!sendType.includes(2)"
        v-model="updateList"
        :file="updateList"
        :disabled="disabled"
      ></accessories-table>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <!-- 审批流 表单流程 -->
      <div class="detial-cont-view">
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <a-button
          v-if="this.affirmState == 0"
          :loading="confirmLoading"
          type="primary"
          class="orange-btn"
          @click="okaffirm"
          :style="{ marginRight: '20px' }"
        >
          确认收到
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? "提交" : "审批" }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <!-- mobilePath="/pages/workbench/partyNotify/details?id=" -->
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      id="txh5/"
      mobilePath="/"
      skipPageReqFlag="/AccountingComputerizationNoticeDetial"
    >
      <div class="print-title">北京民福实业有限公司通知管理审批表单</div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="标题" :span="3">
              {{ Form.titleName }}
            </a-descriptions-item>
            <a-descriptions-item :span="1.5">
              <span slot="label" class="whiteSpace"> 发起部门 </span>
              {{ Form.organizationName }}
            </a-descriptions-item>
            <a-descriptions-item label="发起人" :span="1.5">
              <span v-for="i in queryUserList" :key="i.id">
                <span v-if="i.id == Form.initatorId">{{ i.fullName }}</span>
              </span>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="是否需要回复" :span="1.5">
              {{ Form.isReply == 1 ? '是' : '否' }}
            </a-descriptions-item> -->
            <a-descriptions-item :span="1.5">
              <span slot="label" class="whiteSpace"> 创建时间 </span>
              {{ Form.creationTime }}
            </a-descriptions-item>
            <a-descriptions-item label="主送" :span="3">
              <span v-for="(i, index1) in Form.sendList" :key="index1">
                <span v-for="v in GroupList" :key="v.id">
                  <span v-if="i == v.id" class="printd-item-span">{{
                    v.groupName
                  }}</span>
                </span>
              </span>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="抄送" :span="3">
              <span v-for="(i, index1) in Form.copypresentList" :key="index1">
                <span v-for="v in GroupList" :key="v.id">
                  <span v-if="i == v.id" class="printd-item-span">{{
                    v.groupName
                  }}</span>
                </span>
              </span>
            </a-descriptions-item> -->
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="record => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
let vm = this;
import {
  updatePartyNotice,
  mfNoticePut,
  mfNoticeUserAffirmPartyNotice,
  PartyNoticeDetial,
  mfNoticeListDetails,
  addPartyNotice,
  mfNoticeSave,
  getSendList,
  affirmPartyNotice,
  createWordMF
} from "./api/api";
import { mapState, mapActions } from "vuex";
import approvalSubmission from "@/components/approval-submission/index";
import approvalChart from "@/components/approval-chart/index";
import { activitiSubmission } from "@/utils/utils";
import AccessoriesTable from "@/components/accessories-table/index.vue";
export default {
  components: {
    approvalSubmission,
    approvalChart,
    AccessoriesTable
  },
  data() {
    return {
      WorkLoading: false,
      confirmLoading: false,
      loading: false,
      tabnum: "1", // 1表单页面， 2审批流页面
      Form: {},
      id: "",
      dateFormat: "YYYY-MM-DD",
      // 富文本
      editor: null,
      editorContent: "",
      isDisabledTrue: true,
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 打印部分
      isPrint: false, // 打印弹窗
      columns: [
        {
          title: "审批部门（人）",
          dataIndex: "dutyOfficerStr",
          key: "dutyOfficerStr",
          align: "left"
        },
        {
          title: "审批意见",
          dataIndex: "fieldValue1",
          key: "fieldValue1",
          align: "left"
        },
        {
          title: "审批时间",
          dataIndex: "createTime",
          key: "createTime",
          align: "left"
        }
      ],
      formDTOList: [],
      pIsedit: "",
      updateList: null,
      GroupList: [],
      TypeLoading: false,
      okaffirmid: "",
      affirmState: 1,
      checkboxOptions: [
        {
          label: "站内通知",
          value: 1
        },
        {
          label: "短信通知",
          value: 2
        }
      ],
      sendType: [1]
    };
  },
  computed: {
    ...mapState({
      organizationUserList: state => state.app.organizationUserList, // 当前用户可选部门
      queryUserList: state => state.app.queryUserList // 用户列表
      //  GroupList: (state) => state.app.GroupList, // 分组列表
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function() {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false;
      } else {
        this.proQueryParams = this.$route.query;
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === "100" ||
            this.proQueryParams.isEdit === "1"
          ) {
            return true;
          } else {
            return false;
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true;
        } else {
          // 草稿箱或退回状态  可编辑
          return false;
        }
      }
    }
  },
  created() {
    vm = this;
    this.getorganizationUserList();
    this.getqueryUserList();
    getSendList({ page: 1, size: 100 }).then(res => {
      // console.log('GroupList', res)
      if (res.data.code == 0) {
        this.GroupList = res.data.data;
      }
    });
  },
  mounted() {
    this.okaffirmid = this.$route.query.okaffirmid;
    this.affirmState = this.$route.query.affirmState;
    this.id = this.$route.query.id ? this.$route.query.id : "";
    if (this.id) {
      this.PartyNoticeDetialGian();
    } else {
      this.Form.initatorId = this.$store.state.app.userInfo.id;
      this.$set(
        this.Form,
        "organizationId",
        this.$store.state.app.organizationId
      );
      this.Form.sendType = 1;
    }
    // 判断富文本是否可编辑
    if (!this.disabled) {
      // 可编辑
      this.isDisabledTrue = true;
      this.wangeditorFn();
    } else {
      this.isDisabledTrue = false;
      this.wangeditorFn();
    }
  },
  methods: {
    changeSendWay(e) {
      if (this.isEmpty(e)) {
        this.Form.sendType = "";
      } else if (e.join(",") == 1) {
        this.Form.sendType = 1;
      } else if (e.join(",") == 2) {
        this.Form.sendType = 2;
      } else if (e.join(",") == "1,2") {
        this.Form.sendType = 3;
      }
    },
    ...mapActions(["getorganizationUserList", "getqueryUserList"]),
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    createWork() {
      //生成work文档
      //生成work文档
      this.WorkLoading = true;
      createWordMF(this.id).then(res => {
        if (res.data.code == 0) {
          // 查看
          this.WorkLoading = false;
          let item = res.data.data;
          if (item.fileformat == "bpmn") {
            this.$message.error("该文件类型(bpmn)系统暂时不支持在线预览");
          } else {
            let Base64 = require("js-base64").Base64;
            window.open(
              item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
            );
          }
        } else {
          this.WorkLoading = false;
        }
      });
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList;
      this.isPrint = true;
      document.title =
        "通知管理-" + this.Form.titleName + this.$printFormatDate(new Date());
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case "1":
          // 提交
          this.$confirm({
            title: "您是否提交?",
            onOk: () => {
              activitiSubmission(this.proQueryParams, "1", this);
            },
            onCancel: () => {
              console.log("Cancel");
            }
          });
          break;
        case "2":
          // 取消
          this.$confirm({
            title: "您是否删除?",
            onOk: () => {
              activitiSubmission(this.proQueryParams, "2", this);
            },
            onCancel: () => {
              console.log("Cancel");
            }
          });
          break;
        default:
          break;
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams;
      } else {
        this.PartyNoticeDetialGian();
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      };
    },
    PartyNoticeDetialGian() {
      // 获取详情  PartyNoticeDetial
      mfNoticeListDetails({ id: this.id }).then(res => {
        if (res.data.code == 0) {
          this.Form = res.data.data;
          this.Form.initatorId = parseInt(this.Form.initatorId);
          this.sendType = [];
          if (this.Form.sendType == 1) {
            this.sendType.push(1);
          } else if (this.Form.sendType == 2) {
            this.sendType.push(2);
          } else if (this.Form.sendType == 3) {
            this.sendType.push(1);
            this.sendType.push(2);
          }
          this.updateList = this.Form.pnfiles;
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          };
          Object.assign(this.proQueryParams, processInstanceId);
          setTimeout(() => {
            this.editor.setContent(res.data.data.text);
          }, 600);
        }
      });
    },
    wangeditorFn() {
      // 初始化百度ueditor富文本
      UE.delEditor("editor");
      UE.getEditor("editor", {
        initialFrameWidth: "100%",
        initialFrameHeight: 450, // 设置默认高度
        scaleEnabled: true // 不自动拉伸高度
      });
      this.editor = UE.getEditor("editor", {
        // initialContent: '请输入内容', // 初始化编辑器的内容,也可以通过textarea/script给值
        BaseUrl: "",
        UEDITOR_HOME_URL: vm.$bdPackConfig.baiduEditorUrl,
        autoFloatEnabled: false
      });
      UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl;
      UE.Editor.prototype.getActionUrl = function(action) {
        // let ts = this
        if (action === "upload") {
          return vm.$bdPackConfig.baiduUploadUrl;
        } else {
          return this._bkGetActionUrl.call(this, action);
        }
      };
      let ue = UE.getEditor("editor");
      if (!this.isDisabledTrue) {
        // 处理all-editor报错 无法禁用富文本问题
        document.getElementById("edui1_toolbarbox").style.display = "none";
        ue.ready(function() {
          ue.setDisabled();
        });
      } else {
        ue.ready(function() {
          ue.setEnabled();
        });
      }
    },
    goback() {
      // this.$router.push("/AccountingComputerizationNotice");
      this.$router.go(-1);
    },

    preserveFn(type) {
      if (type === "0") {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = "1";
        this.Form.draft = 2;
      } else {
        this.pIsedit = "2";
        this.Form.draft = 1;
      }
      this.saveFormFn("保存");
    },

    submitFn() {
      this.Form.draft = 2;
      this.saveFormFn("添加");
    },
    okaffirm() {
      mfNoticeUserAffirmPartyNotice(this.okaffirmid).then(res => {
        if (res.data.code == 0) {
          // this.$message.success('')
          this.goback();
        }
      });
    },
    // 输入框限制85
    eightyfive(v) {
      if (this.Form[v].length > 85) {
        this.Form[v] = this.Form[v].substring(0, 85);
        this.$message.destroy();
        this.$message.warning("只能输入85个字");
      }
    },
    saveFormFn(type) {
      this.Form.pnfiles = this.updateList;
      if (this.Form.sendType == 1) {
        this.Form.text = this.editor.getContent();
      }

      if (!this.Form.organizationId) {
        this.$message.error("请添加部门");
        return false;
      }
      if (this.isEmpty(this.sendType)) {
        this.$message.error("通知方式不能为空");
        return false;
      }
      // if (!this.Form.isReply) {
      //   this.$message.error("请选择是否需要回复");
      //   return;
      // }
      if (!this.Form.text) {
        this.$message.error("请添加正文");
        return;
      }
      this.confirmLoading = true;
      this.Form.appId = this.$route.meta.appId;
      // this.Form.appId = this.$APPID.GWZAPPID
      // this.Form.appId="b0c718655d4267f1dc19acc91b671544"
      this.Form.skipPageReqFlag = "/notificationDetail";
      if (this.pIsedit === "") {
        this.loading = true;
      } else {
        this.confirmLoading = true;
      }
      if (this.id) {
        //mfNoticePut updatePartyNotice
        this.Form.copypresentList = [];
        mfNoticePut(this.Form).then(res => {
          if (res.data.code == 0) {
            if (this.pIsedit === "1") {
              this.$message.success("保存成功");
              this.pIsedit = "";
            } else {
              if (this.Form.state > 0) {
                this.PartyNoticeDetialGian();
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === "1" &&
                  this.Form.state != "3"
                ) {
                  this.approvalPro();
                } else {
                  this.cancelPro("1");
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.$message.success("提交成功");
                  this.goback();
                } else {
                  this.$message.success("保存成功");
                }
              }
            }
            this.loading = false;
            this.confirmLoading = false;
          } else {
            this.loading = false;
            this.confirmLoading = false;
          }
        });
      } else {
        //获取部门名称
        let organizationName = "";
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname;
          }
        });
        this.Form.organizationName = organizationName;
        this.Form.copypresentList = [];
        console.log("this.Form", this.Form);
        //return
        //新增 addPartyNotice mfNoticeSave
        mfNoticeSave(this.Form).then(res => {
          if (res.data.code == 0) {
            this.$message.success(type + "成功");
            if (this.Form.draft == 2) {
              this.goback();
            } else {
              //首次添加
              this.id = res.data.data;
              this.PartyNoticeDetialGian();
            }
            this.loading = false;
            this.confirmLoading = false;
          } else {
            this.loading = false;
            this.confirmLoading = false;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edui-default {
  width: 857px;
  margin: 20px auto;
}

.card-title {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.addAccountingComputerizationNotice {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
      position: relative;
      .title-btn {
        position: absolute;
        top: 10px;
        right: 30px;
      }
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-text: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-text: flex-end;
  }
}
.whiteSpace {
  white-space: nowrap;
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/notification/detail.vue